import React, { useState, useEffect, useRef } from 'react';
import './popup.css';


import patientOnboarding from "../../assets/images/Patient Onboarding.png"
import patientOnboarding2 from "../../assets/images/Patient Onboarding 2 .png"

import GRA from "../../assets/images/Genetic RIsk Assessment.png"
import GRA2 from "../../assets/images/Genetic Risk Assessment 2.png"

import DD1 from "../../assets/images/Differential Diagnoses.png"
import DD2 from "../../assets/images/Differential Diagnoses2.png"
import DD3 from "../../assets/images/Differential Diagnoses3.png"
import DD4 from "../../assets/images/Differential Diagnoses4.png"
import DD5 from "../../assets/images/Differential Diagnoses5.png"

import EHR from "../../assets/images/EHR BASED Phenotyping.png"
import EHR2 from "../../assets/images/EHR Based Phenotyping 2.png"

import PGI from "../../assets/images/Phenotype to genotype identification.png"

const ContentPopup = () => {
    const [hasAnimated, setHasAnimated] = useState([false, false, false, false, false]);
    const [visibleSections, setVisibleSections] = useState([false, false, false, false, false]); // Visibility control

    const sectionRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    useEffect(() => {
        const observers = sectionRefs.map((ref, index) => {
            return new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !hasAnimated[index]) {
                        setHasAnimated((prev) => {
                            const updated = [...prev];
                            updated[index] = true;
                            return updated;
                        });

                        setVisibleSections((prev) => {
                            const updated = [...prev];
                            updated[index] = true;
                            return updated;
                        });
                    }
                },
                { threshold: 0.7 }
            );
        });

        sectionRefs.forEach((ref, index) => {
            if (ref.current) observers[index].observe(ref.current);
        });

        return () => {
            sectionRefs.forEach((ref, index) => {
                if (ref.current) observers[index].unobserve(ref.current);
            });
        };
    }, [hasAnimated]);

    return (
        <div className="content-container">
            {/* Section 1 */}
            <div
                ref={sectionRefs[0]}
                className={`flex mt-14 ml-10 h-[560px] ${visibleSections[0] ? 'fadein' : 'fadein-hidden'}`}
            >
                <div className="w-1/2 ss img-container flex items-center">
                    <img src={patientOnboarding} alt="ss1" className='img-skewed-left' />
                    <img src={patientOnboarding2} alt="ss1" className='img-skewed-left' />
                </div>
                <div className="w-1/2 flex flex-col ml-4 mt-16">
                    <div className="inline-flex w-[61px] h-[61px] bg-[#F97316] rounded-full justify-center items-center mt-8">
                        <h3 className="text-[#fff] text-[28px] font-bold">1</h3>
                    </div>

                    <div className="inline-flex flex-col">
                        <h1
                            className={`text-[42px] text-[#1E3A8A] leading-[42px] font-bold text-start mt-8 ${hasAnimated[0] ? 'fadein-typing' : ''}`}
                        >
                            Patient Onboarding
                        </h1>

                        <h5
                            className={`text-[22px] text-[#14B8A6] leading-[32px] font-semibold text-start mt-8 ${hasAnimated[0] ? 'fadein-typing' : ''}`}
                        >
                            Smart intake, seamless experiences
                        </h5>

                        <p
                            className={`text-[18px] text-[#000] leading-[30px] font-regular text-start mt-8 w-auto font-medium ${hasAnimated[0] ? 'fadein-typing' : ''}`}
                        >
                            Simplify and automate patient intake with structured
                            <br />
                            forms, family history capture, and EHR integration
                            <br />
                            ensuring no critical clinical detail is missed.
                        </p>
                    </div>
                </div>
            </div>

            {/* Section 2 */}
            <div
                ref={sectionRefs[1]}
                className={`flex mt-16 ml-10 mr-6 h-[560px] ${visibleSections[1] ? 'fadein' : 'fadein-hidden'}`}
            >
                <div className="w-1/2 mt-2 flex flex-col">
                    <div className="inline-flex w-[61px] h-[61px] bg-[#F97316] rounded-full justify-center items-center  mt-16">
                        <h3 className="text-[#fff] text-[28px] font-bold">2</h3>
                    </div>

                    <h1
                        className={`text-[42px] text-[#1E3A8A] leading-[38px] font-bold text-start mt-8 w-[600px] ${hasAnimated[1] ? 'fadein-typing' : ''}`}
                    >
                        Genetic Risk Assessment
                    </h1>

                    <h5
                        className={`text-[22px] text-[#14B8A6] leading-[32px] font-semibold text-start mt-8 w-[600px] ${hasAnimated[1] ? 'fadein-typing' : ''}`}
                    >
                        Comprehensive, personalized risk profiling
                    </h5>

                    <p
                        className={`mx-auto text-[18px] text-[#000] leading-[32px] font-regular text-start mt-8 font-medium pr-24 ${hasAnimated[1] ? 'fadein-typing' : ''}`}
                    >
                        Combine family history, environment, and clinical data to generate individualized genetic risk scores, enabling proactive care and earlier interventions.
                    </p>
                </div>
                <div className="w-1/2 ss img-container flex items-center">
                    <img src={GRA} alt="ss1" className='img-skewed-right' />
                    <img src={GRA2} alt="ss1" className='img-skewed-right' />
                </div>
            </div>

            {/* Section 3 */}
            <div
                ref={sectionRefs[2]}
                className={`flex mt-16 ml-10 h-[560px] ${visibleSections[2] ? 'fadein' : 'fadein-hidden'}`}
            >
                <div className="w-1/2 ss img-container flex items-center">
                    <img src={EHR} alt="ss1" className='img-skewed-left' />
                    <img src={EHR2} alt="ss1" className='img-skewed-left' />

                </div>
                <div className="w-1/2 pr-14 flex flex-col ml-4 mt-16">
                    <div className="inline-flex w-[61px] h-[61px] bg-[#F97316] rounded-full justify-center items-center mt-6">
                        <h3 className="text-[#fff] text-[28px] font-bold">3</h3>
                    </div>

                    <h1
                        className={`text-[42px] text-[#1E3A8A] leading-[52px] font-bold text-start mt-6 ${hasAnimated[2] ? 'fadein-typing' : ''}`}
                    >
                        EHR based phenotyping for Differential Diagnosis
                    </h1>

                    <h5
                        className={`text-[22px] text-[#14B8A6] leading-[32px] font-semibold text-start mt-6 ${hasAnimated[2] ? 'fadein-typing' : ''}`}
                    >
                        Get differential diagnosis
                    </h5>

                    <p
                        className={`text-[18px] text-[#000] leading-[32px] font-regular text-start mt-6 ${hasAnimated[2] ? 'fadein-typing' : ''}`}
                    >
                        Use AI to extract structured phenotypes from unstructured EHR data, enabling fast, accurate differential diagnosis through deep phenotype mapping.
                    </p>
                </div>
            </div>

            {/* Section 4 */}
            <div
                ref={sectionRefs[3]}
                className={`flex mt-16 ml-10 mr-6 h-[560px] ${visibleSections[3] ? 'fadein' : 'fadein-hidden'}`}
            >
                <div className="w-1/2 flex flex-col">
                    <div className="inline-flex w-[61px] h-[61px] bg-[#F97316] rounded-full justify-center items-center mt-16">
                        <h3 className="text-[#fff] text-[28px] font-bold">4</h3>
                    </div>

                    <h1
                        className={`text-[42px] text-[#1E3A8A] leading-[52px] font-bold text-start mt-8 ${hasAnimated[3] ? 'fadein-typing' : ''}`}
                    >
                        Rare Disease Detailed Insights
                    </h1>

                    <h5
                        className={`text-[22px] text-[#14B8A6] leading-[32px] font-semibold text-start mt-8 w-[600px] ${hasAnimated[3] ? 'fadein-typing' : ''}`}
                    >
                        Your rare disease knowledge companion
                    </h5>

                    <p
                        className={`text-[18px] text-[#000] leading-[32px] font-regular text-start mt-8 w-auto font-medium pr-24 ${hasAnimated[3] ? 'fadein-typing' : ''}`}
                    >
                        Access curated, evidence-based summaries of rare conditions, including etiology, symptoms, testing options, progression, and management pathways supported by the latest genetic data and clinical evidence.
                    </p>
                </div>
                <div className="w-1/2 ss2 img-container flex items-center">
                    <img src={DD1} alt="ss1" className='img-skewed-right' />
                    <img src={DD2} alt="ss1" className='img-skewed-right' />
                    <img src={DD3} alt="ss1" className='img-skewed-right' />
                    <img src={DD4} alt="ss1" className='img-skewed-right' />
                    <img src={DD5} alt="ss1" className='img-skewed-right' />
                </div>
            </div>

            {/* Section 5 */}
            <div
                ref={sectionRefs[4]}
                className={`flex mt-16 ml-10 h-[560px] ${visibleSections[4] ? 'fadein' : 'fadein-hidden'}`}
            >
                <div className="w-1/2 img-container flex items-center">
                    <img src={PGI} alt="ss1" className='img-skewed-left' />

                </div>
                <div className="w-1/2 flex flex-col ml-4 mt-16">
                    <div className="inline-flex w-[61px] h-[61px] bg-[#F97316] rounded-full justify-center items-center mt-8">
                        <h3 className="text-[#fff] text-[28px] font-bold">5</h3>
                    </div>

                    <h1
                        className={`text-[42px] text-[#1E3A8A] leading-[52px] font-bold text-start mt-8 pr-16 ${hasAnimated[4] ? 'fadein-typing' : ''}`}
                    >
                        Phenotype-to-Genotype Identification
                    </h1>

                    <h5
                        className={`text-[22px] text-[#14B8A6] leading-[32px] font-semibold text-start mt-8 ${hasAnimated[4] ? 'fadein-typing' : ''}`}
                    >
                        From symptoms to causative genes.
                    </h5>

                    <p
                        className={`text-[18px] text-[#000] leading-[32px] font-regular text-start mt-8 w-[600px] font-medium pr-24 ${hasAnimated[4] ? 'fadein-typing' : ''}`}
                    >
                        Map clinical phenotypes to prioritize genes and variants using integrated HPO, Orphanet, and OMIM data streamlining diagnosis and test selection.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContentPopup;
